import { Anchor, type _Navigation } from ":setup/qrouter";
import { default as routes } from "../routes";
import { LockedAnchor } from ":src/components/overlays";
import { global } from ":shared/app";
export default function ProjectSubmission(props: _Navigation.SideNavJSXItemProps) {
  const $settings = global.store.hooks.platform.useSettings("submission");
  return (
    <Anchor
      class={`relative  ${props?.anchor?.class}`}
      setup={{
        to: routes,
        classes: {
          active: `${props.anchor.setup.classes.active}`,
        },
      }}
      events={{
        getShouldNavigate: () => !$settings().locked,
      }}
      triggers={{
        onBeforeNavigate: () => {
          if ($settings().locked) {
            global.store.actions.toast.pushToast({
              type: "error",
              message: "This page is locked by admin, you can't access it right now!",
            });
          }
        },
      }}
      components={{
        title: "Project Submission",
        idleIcon: <i class="i-mingcute:flag-4-line" />,
        activeIcon: <i class="i-mingcute:flag-4-line" />,
      }}
    >
      <LockedAnchor locked={$settings().locked} />
    </Anchor>
  );
}
